import React, { FC, ReactNode } from "react";
import { SvgIcon } from "../../SvgIcon/SvgIcon";
import classNames from "classnames";
import { Icons } from "../../SvgIcon/types";

interface ButtonProps {
    type?: "button" | "submit";
    className?: string;
    onClick?: () => void;
    children: ReactNode;
    leftIcon?: Icons;
    rightIcon?: Icons;
    variant?: "primary" | "secondary";
    disabled?: boolean;
    size?: "small" | "medium" | "large"
    fullWidth?: boolean;
}

export const Button: FC<ButtonProps> = ({type = "submit", variant = "primary", size = "medium", fullWidth, disabled, className, onClick, children, leftIcon, rightIcon}: ButtonProps) => {

    return (
        <button 
            className={classNames(
                "Button",
                {"Button--secondary": variant === "secondary"},
                {"Button--small": size === "small"},
                {"Button--medium": size === "medium"},
                {"Button--large": size === "large"},
                {"Button--fullWidth": fullWidth},
                className
            )}
            type={type}
            onClick={onClick}
            disabled={disabled}
        >
            {leftIcon && <SvgIcon iconName={leftIcon} />}
            {children}
            {rightIcon && <SvgIcon iconName={rightIcon} />}
        </button>
    );
};
